import React from "react";

const Footer = () => {
  return (
    <div className="text-xs3 text-center text-gray-700 p-1">
      © {new Date().getFullYear()} - Confie Inquiry
    </div>
  );
};

export default Footer;
